import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import {
  history,
  LOADING,
  ASYNC_CREATE_ACTION,
  ASYNC_EDIT_ACTION,
  ASYNC_CHANGE_STATUS_ACTION,
  ASYNC_EDIT_ACTION_CREATIVE,
  ASYNC_CREATE_COMPROVATION,
  ASYNC_COMPROVATION_APPROVAL,
} from 'store';
import swal from '../../helpers/swal';

function* createAction({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    let path = '/actions';
    if (payload.has('marketing_plan_id')) {
      path = `/marketing-plans/edit/${payload.get('marketing_plan_id')}`;
    }
    yield call(api.post, 'actions', payload, {
      headers: {
        'X-Success-Message': 'Ação cadastrada com sucesso!',
        'X-Redirect': path,
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editAction({ payload }) {
  yield put({ type: LOADING, payload: true });
  try {
    let path = '/actions';
    let from = window.history.state && window.history.state.state && window.history.state.state.from ? window.history.state.state.from : '' ;    
    if (from.indexOf('marketing-plans') != -1) {
      path = from;
    }
    yield payload.append('_method', 'PUT');
    yield call(api.post, `actions/${payload.get('id')}`, payload, {
      headers: {
        'X-Success-Message': payload.get("message_alert"), 
        'X-Redirect': path,
        'X-Show-Alert': true
      }
    });
  } catch (error) {
    console.log(error)
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* changeStatusAction({ payload }) {
  yield put({ type: LOADING, payload: true });
  try {
    yield call(api.post, 'actions/approve', payload, {
      headers: {
        'X-Success-Message': payload.get('message_alert'), 
        'X-Redirect': '/actions',
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editActionCreative({ payload }) {
  yield put({ type: LOADING, payload: true });
  try {
    yield payload.append('_method', 'PUT');
    yield call(api.post, `action-comprovations/${payload.get('id')}`, payload, {
      headers: {
        'X-Success-Message': 'Arte enviada para aprovação', 
        'X-Redirect': `/creative/show/${payload.get('action_task_item_id')}`,
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* saveComprovationCreative({ payload }) {
  yield put({ type: LOADING, payload: true });
  try {
    yield call(api.post, 'action-comprovations', payload, {
      headers: {
        'X-Success-Message': 'Arte enviada para aprovação', 
        'X-Redirect': '/creative',
        'X-Show-Alert': true
        
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* comprovationApproval({ payload }) {
  try {
    yield payload.append('_method', 'PUT');
    yield call(api.post, `action-comprovations/${payload.get('id')}`, payload, {
      headers: {
        'X-Success-Message': payload.get('message_alert'), 
        'X-Show-Alert': true
      }
    });
    // yield call(
    //   history.push,
    //   `/actions/edit/${payload.get('action_id')}`,
    //   payload
    // );
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

export default function* root() {
  yield all([
    takeLatest(ASYNC_CREATE_ACTION, createAction),
    takeLatest(ASYNC_EDIT_ACTION, editAction),
    takeLatest(ASYNC_CHANGE_STATUS_ACTION, changeStatusAction),
    takeLatest(ASYNC_EDIT_ACTION_CREATIVE, editActionCreative),
    takeLatest(ASYNC_CREATE_COMPROVATION, saveComprovationCreative),
    takeLatest(ASYNC_COMPROVATION_APPROVAL, comprovationApproval),
  ]);
}
